import { instance } from 'api/core';
import { CallbackObject } from 'api/core/get-page-function';
import { AxiosResponse } from 'axios';
import { plainToClass } from 'class-transformer';
import { GetProductSerialNumbersVm } from './get-product-serial-numbers.vm';

export const getProductSerialNumbers = async (
  productId: string,
  term: string | null,
  offset: string,
  limit: number,
  callback: CallbackObject<GetProductSerialNumbersVm>
) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: limit ?? 50,
      offset: offset,
    },
  };

  if (term) {
    config.params.term = term;
  }

  try {
    const res: AxiosResponse = await instance.get(`/catalog/products/${productId}/serial-numbers`, config);
    callback.success(plainToClass(GetProductSerialNumbersVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
